<template>
  <div
    class="save-tray-block container my-5"
    id="imageModal"
    tabindex="-1"
    role="dialog"
  >
    <label class=" border-0">
      {{ $resourceString['myProject.Project.UploadProjectCover.Title'] }}
      <div class="col-12 font-16 text-muted text-size-normal">
        {{ description }}
        <div class="board-cover-crop">
          <div class="nav mb-3 nav-tabs nav-justified">
            <a
              href=""
              class="nav nav-item nav-link text-size-normal"
              data-tab="cover"
              :class="getTab === 'cover' ? 'active' : ''"
              @click.prevent="handleTabClick"
            >{{ $resourceString['myProject.Project.CoverView'] }}
            </a>
            <a
              href=""
              class="nav nav-item nav-link text-size-normal"
              :class="getTab === 'thumbnail' ? 'active' : ''"
              data-tab="thumbnail"
              @click.prevent="handleTabClick"
            >
           {{$resourceString['myProject.Project.ThumbnailView']}}
            </a>
          </div>
        </div>
      </div>
      <div class="tray-cover-undashed">
        <span v-if="!getFileUrl" class="btn btn-primary call-to-action-button">
          {{ $resourceString["virtualtray.Savetray.UploadImage.Button"] }}
        </span>

        <pc-project-crop-viewer
          v-if="getTab === 'cover'"
          :src="getFileUrl"
          :ratio="4"
          :height="staticHeight"
          :options="options"
        >
        </pc-project-crop-viewer>
        <pc-project-crop-viewer
          v-if="getTab === 'thumbnail'"
          :src="getFileUrl"
          :ratio="360 / 220"
          :height="staticHeight"
          :options="options"
        >
        </pc-project-crop-viewer>
      </div>
    </label>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-primary"
        data-dismiss="modal"
        @click="
          () => {
            hideModal('project-upload-image');
            startOverOrCancel( Object.keys(this.getUploadImageResp).length === 0 ? true : false);
          }"
      >
        {{ $resourceString["virtualtray.Savetray.Cancel.Button"] }}
      </button>

      <button
        type="button"
        class="btn btn-primary"
        :disabled="!this.getImageCoverData || !this.getImageThumbnailData || this.imageButtonDisabled"
        @click="handleUploadImage($event)"
      >
        {{ $resourceString["virtualtray.Savetray.Image.Select.Button"] }}
      </button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import pcProjectCropViewer from "./pc-project-crop-viewer.vue";

export default {
  computed: {
    ...mapGetters({
      getFileName: "myProject/getFileName",
      getFileUrl: "myProject/getFileUrl",
      getTab :"myProject/getTab",
      getImageCoverData:"myProject/getImageCoverData",
      getImageThumbnailData:"myProject/getImageThumbnailData",
      gettrayEditId: "myTray/gettrayEditId",
      getUploadImageResp: "myTray/getUploadImageResp",


    })
  },
  components: {
    pcProjectCropViewer
  },
  data() {
    return {
      options: {
        movable: false,
        viewMode: 1,
        guides: false,
        center: false,
        background: false,
        highlight: false,
        toggleDragModeOnDblclick: false,
        zoomable: false,
      },
      formData: new FormData(),
      selectedFile: File,
      imageSrc: "",
      uploadFile: null,
      staticHeight: "300px",
      description: this.$resourceString['myProject.Project.ProjectCover.Description'],
      active: this.$resourceString['common.accounts.Label.Active'],
      cover: this.$resourceString['common.accounts.Label.Cover'],
      thumbnail: this.$resourceString['common.accounts.Label.Thumbnail'],
      flag:false,
      imageButtonDisabled: false

    };
  },
  mounted() {
    this.getNewFileName(this.getFileName);
  },

  methods: {
    ...mapActions({
      uploadImage: "myProject/uploadImage",
      updateImageBlobd: "myTray/updateImageBlobd",
      resourceString: "myTray/resourceString",
      startOverOrCancel: "myProject/startOverOrCancel",
      selectAnotherImage: "myProject/selectAnotherImage",
      setTab :"myProject/setTab",

    }),
    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },

    async handleUploadImage() {
      this.imageButtonDisabled = true;
      let data = {
        Id: this.gettrayEditId,
        Asset: this.getFileName
      };
      await this.resourceString(
        this.$resourceString["virtualtray.Tray.Uploaded.Msg"]
      );
      await this.uploadImage(data);
      this.hideModal("project-upload-image");
      this.flag = true;
      this.imageButtonDisabled = false;
    },
    handleFileChange(event) {
      this.getFileName = event.target.files[0];
    },
    getNewFileName(newFile) {
      if (newFile) {
        this.imageSrc = URL.createObjectURL(newFile);
        this.updateImageBlobd(this.imageSrc);
      } else {
        URL.revokeObjectURL(this.imageSrc);

        this.imageSrc = "";
        this.updateImageBlobd(this.imageSrc);
      }
    },
    handleUseAnotherImg() {
      this.hideModal("upload-image");
      this.startOverOrCancel(true);
    },
    handleTabClick(event) {
      const tabNumber = event.currentTarget.getAttribute("data-tab");
      this.setTab(tabNumber);
      this.description =
        this.getTab === "cover"
          ? this.$resourceString['myProject.Project.ProjectCover.Description']
          : this.$resourceString['myProject.Project.ProjectThumbnail.Description'];
    }
  },
  beforeDestroy(){
    if(!this.flag){
      this.startOverOrCancel(true);
    }
    this.setTab("cover");
  }
};
</script>
